"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The OrderPos model module.
 * @module model/OrderPos
 * @version 1.0.44
 */
var OrderPos = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>OrderPos</code>.
   * 
   * @alias module:model/OrderPos
   */
  function OrderPos() {
    _classCallCheck(this, OrderPos);
    OrderPos.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(OrderPos, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>OrderPos</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderPos} obj Optional instance to populate.
     * @return {module:model/OrderPos} The populated <code>OrderPos</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new OrderPos();
        if (data.hasOwnProperty('warenkorbPos')) {
          obj['warenkorbPos'] = _ApiClient.default.convertToType(data['warenkorbPos'], 'Number');
        }
        if (data.hasOwnProperty('auftragsNr')) {
          obj['auftragsNr'] = _ApiClient.default.convertToType(data['auftragsNr'], 'String');
        }
        if (data.hasOwnProperty('sepaMandatsref')) {
          obj['sepaMandatsref'] = _ApiClient.default.convertToType(data['sepaMandatsref'], 'String');
        }
        if (data.hasOwnProperty('endBetrag')) {
          obj['endBetrag'] = _ApiClient.default.convertToType(data['endBetrag'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OrderPos</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OrderPos</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['auftragsNr'] && !(typeof data['auftragsNr'] === 'string' || data['auftragsNr'] instanceof String)) {
        throw new Error("Expected the field `auftragsNr` to be a primitive type in the JSON string but got " + data['auftragsNr']);
      }
      // ensure the json data is a string
      if (data['sepaMandatsref'] && !(typeof data['sepaMandatsref'] === 'string' || data['sepaMandatsref'] instanceof String)) {
        throw new Error("Expected the field `sepaMandatsref` to be a primitive type in the JSON string but got " + data['sepaMandatsref']);
      }
      return true;
    }
  }]);
}();
/**
 * Position in der Warenkorbliste
 * @member {Number} warenkorbPos
 */
OrderPos.prototype['warenkorbPos'] = undefined;

/**
 * Nummer des Auftrags
 * @member {String} auftragsNr
 */
OrderPos.prototype['auftragsNr'] = undefined;

/**
 * Mandantenreferent des Auftrags
 * @member {String} sepaMandatsref
 */
OrderPos.prototype['sepaMandatsref'] = undefined;

/**
 * Betrag des Auftrags
 * @member {Number} endBetrag
 */
OrderPos.prototype['endBetrag'] = undefined;
var _default = exports.default = OrderPos;